import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-act',
    templateUrl: './act.component.html',
    styleUrls: ['./act.component.scss']
})
/** act component*/
export class ActComponent {
  /** act ctor */
  act: any;
  route: any;
  MenuList: any;
  title: any;
  fileUrl: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  actCount: any;
  currentDate: any = new Date();
  modeltitle: any;
  content: any;
  image: any;
  multipleEntry: boolean = false;
  imgUrl: any;
  actSpinner: boolean;
  constructor(private spinner: NgxSpinnerService, private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderpipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.fileUrl = window["getfile"];
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.spinner.show()
    this.paginationPageNumber = 1;
    this.itemsPerPage = 5;
    this.getMenuName();
    this.getact();

  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.title = this.MenuList[0].title;
      this.multipleEntry = this.MenuList[0].multipleEntry;
    });
  }

  getact() {
    this.actSpinner = true;
    this.http.get(this.appComponent.APIUrl + 'Post/GetPostByRoute/' + this.route, {
    }).subscribe((data: any) => {
      this.actSpinner = false;
      this.act = data.postDTO.filter(x => x.status == 'Active' && x.displayonhome == 1);
      this.actCount = this.act.length;
      this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd' + 'T00:00:00');
    });
  }
  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
